__turbopack_context__.v({
  "contentsItem": "PlasmicListItem-module__VNBpBG__contentsItem",
  "icon": "PlasmicListItem-module__VNBpBG__icon",
  "svg__rg9Cj": "PlasmicListItem-module__VNBpBG__svg__rg9Cj",
  "text16": "PlasmicListItem-module__VNBpBG__text16",
});
